export default {
  title: 'Partner',
  search_placeholder: 'Partner suchen...',
  buttons: {
    default_price_list: 'Standard-Preisliste',
    create_partner: 'Partner erstellen',
  },
  columns: {
    name: 'Name',
    restaurants: 'Restaurants',
    shop_domain: 'Shop-Domain',
    status: 'Status',
    earning_enabled: 'Beteiligung aktiv',
  },
  statuses: {
    invited: 'Eingeladen',
    active: 'Aktiv',
    suspended: 'Gesperrt',
  },
  actions: {
    edit: 'Bearbeiten',
    view_billing: 'Abrechnung ansehen',
    view_as_partner: 'Als Partner ansehen',
    suspend: 'Sperren',
    unsuspend: 'Entsperren',
  },
  suspension: {
    suspend_title: 'Diesen Partner sperren?',
    suspend_description:
      'Alle Teammitglieder des Partners werden deaktiviert und ihre Sitzungen beendet. Die Restaurants bleiben online.',
    unsuspend_title: 'Diesen Partner entsperren?',
    unsuspend_description: 'Alle Teammitglieder des Partners werden reaktiviert und können sich wieder anmelden.',
  },
  toasts: {
    load_error: 'Partner konnten nicht geladen werden.',
    suspended: 'Der Partner wurde gesperrt.',
    unsuspended: 'Der Partner wurde entsperrt.',
    suspension_error: 'Der Partnerstatus konnte nicht geändert werden.',
    view_as_error: 'Das Partner-Dashboard konnte nicht geöffnet werden.',
  },
};
